import getOperation from "../../helpers/getOperation"

import AuthenticateAsOutputShape from "./AuthenticateAsOutputShape"
import AuthenticateOutputShape from "./AuthenticateOutputShape"
import CreateMyPersonalAccessTokenOutputShape from "./CreateMyPersonalAccessTokenOutputShape"
import CreateOrganizationPublicKeyOutputShape from "./CreateOrganizationPublicKeyOutputShape"
import IndexMyPersonalAccessTokensOutputShape from "./IndexMyPersonalAccessTokensOutputShape"
import IndexOrganizationPublicKeyAuthenticationsOutputShape from "./IndexOrganizationPublicKeyAuthenticationsOutputShape"
import IndexOrganizationPublicKeysOutputShape from "./IndexOrganizationPublicKeysOutputShape"
import RevokeMyPersonalAccessTokenOutputShape from "./RevokeMyPersonalAccessTokenOutputShape"
import RevokeOrganizationPublicKeyOutputShape from "./RevokeOrganizationPublicKeyOutputShape"
import StartTotpSetupOutputShape from "./StartTotpSetupOutputShape"

export {
  AuthenticateAsOutputShape,
  AuthenticateOutputShape,
  CreateMyPersonalAccessTokenOutputShape,
  CreateOrganizationPublicKeyOutputShape,
  IndexMyPersonalAccessTokensOutputShape,
  IndexOrganizationPublicKeyAuthenticationsOutputShape,
  IndexOrganizationPublicKeysOutputShape,
  RevokeMyPersonalAccessTokenOutputShape,
  RevokeOrganizationPublicKeyOutputShape,
  StartTotpSetupOutputShape
}

export const authenticateOperation = getOperation("identity/Authenticate")
export const authenticateAsOperation = getOperation("identity/AuthenticateAs")
export const changeMyIdentityEmailOperation = getOperation("identity/ChangeMyIdentityEmail")
export const confirmMyIdentityEmailOperation = getOperation("identity/ConfirmMyIdentityEmail")
export const createMyPersonalAccessTokenOperation = getOperation("identity/CreateMyPersonalAccessToken")
export const createOrganizationPublicKeyOperation = getOperation("identity/CreateOrganizationPublicKey")
export const indexMyPersonalAccessTokensOperation = getOperation("identity/IndexMyPersonalAccessTokens")
export const indexOrganizationPublicKeyAuthenticationsOperation = getOperation("identity/IndexOrganizationPublicKeyAuthentications")
export const indexOrganizationPublicKeysOperation = getOperation("identity/IndexOrganizationPublicKeys")
export const revokeMyPersonalAccessTokenOperation = getOperation("identity/RevokeMyPersonalAccessToken")
export const revokeOrganizationPublicKeyOperation = getOperation("identity/RevokeOrganizationPublicKey")
export const startTotpSetupOperation = getOperation("identity/StartTotpSetup")
export const verifyTotpSetupOperation = getOperation("identity/VerifyTotpSetup")
